import { render } from "./CommPopular_side.vue?vue&type=template&id=bda93f54"
import script from "./CommPopular_side.vue?vue&type=script&lang=js"
export * from "./CommPopular_side.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__